

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface TenantPackageParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface TenantPackage {
    id?: string;
  tenantId: string;
  branchId: string;
  packageId: string;

  parameters?: TenantPackageParameter[];
  links?: any;
}

export abstract class TenantPackageData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(): Observable<TenantPackage[]>;
  abstract create(url: string,data: TenantPackage): Observable<any>;
  abstract createArray(url:string,data:TenantPackage[]): Observable<any>;
  abstract update(url: string,data: TenantPackage): Observable<any>;
  abstract delete(url: string): Observable<any>;
  abstract tenantList(url: string): Observable<any[]>;
 abstract addPackage(url: string,data: any): Observable<any>;
}
